<template>
  <div class="contract-wrapper">
    <base-spinner
      :is-loading="isLoading"
    />
    <div class="contract-heading" v-if="!isLoading">
      <div class="back-btn-container" @click="$router.push({name: 'main'})">
        <img src="../../../public/custom/images/back-arrow.svg" alt="Back arrow" class="back-img">
        <span class="back-btn-text">{{ $t('message.passwordRecovery.backBtn') }}</span>
      </div>
    </div>
    <div class="contract-container" v-if="!isLoading">
      <div class="contract-title">
        Договор займа ID {{ agreementId }}
      </div>
      <div class="contract-date">
        от {{ date }}г.
      </div>
      <p class="indented-paragraph">
        1. Если из текста настоящего договора прямо не вытекает иное, следующие термины будут иметь указанные ниже значения:
      </p>
      <p class="indented-paragraph">
        <b>«Сервис»</b> – комплекс программного обеспечения «Капуста – онлайн-заимствования», доступный по доменному адресу (сайт) в глобальной компьютерной сети Интернет: <a href="https://www.kapusta.by" target="_blank">www.kapusta.by</a> и <a href="https://www.капуста.бел" target="_blank">www.капуста.бел</a>, исключительные права на которое принадлежат Обществу с ограниченной ответственностью «Инновационные Финансовые Стратегии».
      </p>
      <p class="indented-paragraph">
        <b>Оператор сервиса онлайн-заимствования</b> – Общество с ограниченной ответственностью «Инновационные Финансовые Стратегии», (далее – <b>Оператор</b>), УНП 193601287, свидетельство Национального банка Республики Беларусь №1 от 14.01.2022 с правом осуществления деятельности Оператора сервиса онлайн-заимствования.
      </p>
      <p class="indented-paragraph">
        <b>МСИ</b> – межбанковская система идентификации, порядок функционирования которой определен законодательством Республики Беларусь.
      </p>
      <p class="indented-paragraph">
        <b>«Правила»</b> – правила работы сервиса потребительского онлайн-заимствования, утвержденные руководителем Оператора.
      </p>
      <p class="indented-paragraph">
        <b>«ДВУ»</b> – договор возмездного оказания услуг между Оператором и клиентом на предложенных условиях (в рамках публичной оферты). После принятия условий ДВУ пользователи становятся Клиентами Сервиса.
      </p>
      <p class="indented-paragraph">
        <b>«Заемщик»</b> – любое дееспособное физическое лицо старше 18 лет, являющееся резидентом Республики Беларусь (за исключением лица, имеющего вид на жительство в Республике Беларусь), зарегистрированное в МСИ и заключившее ДВУ с Оператором.
      </p>
      <p class="indented-paragraph">
        <b>«Заимодавец»</b> – любое дееспособное физическое лицо старше 18 лет, являющееся резидентом Республики Беларусь, зарегистрированное в МСИ и заключившее ДВУ с Оператором.
      </p>
      <p class="indented-paragraph">
        <b>«Заем»</b> – сумма денежных средств в валюте (BYN) Белорусский рубль, предоставляемая Заимодавцем Заёмщику на условиях настоящего Договора и в соответствии с Правилами Оператора и ДВУ.
      </p>
      <p class="indented-paragraph">
        <b>«Заявка»</b> – электронный документ, размещенный Заёмщиком или Заимодавцем на Сервисе, являющийся публичной офертой на заключение Договора Займа с широким кругом потенциальных Заимодавцев или Заёмщиков, являющихся Клиентами Сервиса.
      </p>
      <p class="indented-paragraph">
        <b>Аналог собственноручной подписи (далее –АСП)</b> – аутентификация личности клиента и его волеизъявления в момент совершения юридически значимого действия путем введения им верного значения, сгенерированного Сервисом одноразового шестизначного кода из SMS или push-уведомления, отправленного на номер его телефона, принадлежность которого данному лицу подтверждены Сервисом и МСИ.
      </p>
      <div class="lender-container">
        <div class="name-container">
          <div class="name-item">{{ lenderLastName }}</div>
          <div class="name-item">{{ lenderName }}</div>
          <div class="name-item">{{ lenderMiddleName }}</div>
        </div>
        <div class="email-container">
          <div class="email-item">{{ lenderEmail }}</div>
          <div class="email-item-disabled"></div>
          <div class="email-item-disabled"></div>
        </div>
      </div>
      <p class="not-indented-paragraph">
        именуемый (ая) в дальнейшем «Заимодавец» и
      </p>
      <div class="borrower-container">
        <div class="name-container">
          <div class="name-item">{{ userLastName }}</div>
          <div class="name-item">{{ userName }}</div>
          <div class="name-item">{{ userMiddleName }}</div>
        </div>
        <div class="id-document-container">
          <div class="id-item">{{ userNationalIdNumber }}</div>
          <div class="id-item">{{ userIdDocumentType }}</div>
          <div class="id-item">{{ userIdSeriesNumber }}</div>
          <div class="id-item">{{ userIdIssueDate }}</div>
        </div>
        <div class="id-document-authority">
          <div class="authority-item">{{ userIdAuthority }}</div>
          <div class="authority-email-item">{{ userEmail }}</div>
        </div>
      </div>
      <p class="not-indented-paragraph">
        именуемый (ая) в дальнейшем «Заемщик», а вместе именуемые «Стороны», заключили настоящий Договор о нижеследующем:
      </p>
      <div class="block-title">2. ОБЩИЕ ПОЛОЖЕНИЯ</div>
      <p class="not-indented-paragraph">
        2.1. Сделки по предоставлению займов денежных средств между Сторонами по настоящему Договору заключаются исключительно при помощи и посредничестве Оператора посредством размещения Заявки (оферты) Заемщика и акцепта ее со стороны Заимодавца или принятия (акцепта) Заемщиком условий оферты Заимодавца, размещенных на страницах Сервиса.
      </p>
      <p class="not-indented-paragraph">
        2.2. Юридические последствия (возникновение прав и обязанностей) между Сторонами возникают путем и вследствие совершения действий, свидетельствующих о таком акцепте, в том числе, но не в строгой последовательности и исчерпывающем порядке: в форме команд Сервису, подтверждении согласия с условиями оферты и ее акцептование (присоединение к Договору путем совершения конклюдентных действий), подписания договора посредством АСП, перечисления денежных средств.
      </p>
      <div class="block-title">3. ПРЕДМЕТ ДОГОВОРА</div>
      <p class="not-indented-paragraph">
        3.1. Заимодавец через команду Сервису передает в собственность Заемщику денежные средства в виде процентного займа путем их перечисления (с использованием банковской платежной карточки) на текущий (расчетный) банковский счет Заемщика в размере и сроки, указанные в Заявке Заемщика или Заимодавца, являющихся офертой, а Заемщик принимает от Заимодавца процентный займ и обязуется возвратить ему денежные средства и проценты за пользование займом, согласно всем условиям настоящего Договора. 
      </p>
      <p class="not-indented-paragraph">
        3.2. Договор займа считается заключенным в момент фактического предоставления Заемщику денежных средств путём их перечисления (с использованием банковской платежной карточки) на текущий (расчетный) банковский счет Заемщика в соответствии с указанными им платежными реквизитами и действует до полного исполнения Сторонами своих обязательств по настоящему Договору. 
      </p>
      <p class="not-indented-paragraph">
        3.3. Денежные средства, составляющие сумму займа, передаются Заемщику в соответствии с Правилами Оператора, условиями ДВУ в редакции, действующей на момент совершения соответствующих действий. 
      </p>
      <p class="not-indented-paragraph">
        3.4. На счет Заемщика относятся все банковские расходы (комиссии за перевод, связанные с выдачей суммы займа Заемщику), а также комиссия Оператору, которые должны быть уплачены Заемщиком, но удерживаются Банком с суммы займа, перемещаемой в пользу Заемщика. 
      </p>
      <p class="not-indented-paragraph">
        3.5. На счет Заимодавца относится все банковские расходы (комиссии за перевод, связанные с возвратом суммы займа, уплатой процентов, пени), а также комиссия Оператору, которые должны быть уплачены Заимодавцем, но удерживаются Банком с суммы платежа, перемещаемой в пользу Заимодавца. 
      </p>
      <p class="not-indented-paragraph">
        3.6. Подписанием настоящего Договора Заемщик соглашается с тем, что несмотря на поступление в его пользу суммы Займа меньшей, чем оговорено в его заявке, размещенной на Сайте и акцептованной Заимодавцем или в оферте Заимодавца, акцептованной Заемщиком суммой займа является сумма, поступившая в его пользу от Заимодавца, увеличенная на сумму удержанных Банком комиссий и комиссии Оператору, выплаты которых относятся на счет Заемщика. 
      </p>
      <p class="not-indented-paragraph">
        3.7. Присоединением к условиям настоящего Договора путем предоставления денежных средств в его рамках Заимодавец соглашается с тем, что несмотря на поступление в его пользу суммы платежа, связанного с возвратом суммы Займа, а также уплатой процентов, пени меньшей, чем отправлено Заемщиком, суммой платежа является сумма, поступившая в его пользу от Заемщика, увеличенная на сумму удержанных Банком комиссий и комиссии Оператору, выплаты которых относятся на счет Заимодавца. 
      </p>
      <p class="not-indented-paragraph">
        3.8. Заемщик подтверждает, что денежные средства, оговоренные в п.п. 3.1.,3.3.,3.4.,3.6. составляют сумму займа, и настоящий Договор Займа считается заключенным на оговоренных заявкой на Сервисе условиях с момента поступления таких сумм на счет Заемщика и/или удержания сумм из платежа Заимодавца в пользу Заемщика.
      </p>
      <p class="not-indented-paragraph">
        3.9. Денежные средства, не соответствующие параметрам заявки, например излишне перечисленные денежные средства Заемщику (в том числе по причине технического сбоя в Сервисе) подлежат незамедлительному, добровольному возврату в рамках обязательств, вытекающих из неосновательного обогащения в соответствии с Гражданским кодексом Республики Беларусь.
      </p>
      <p class="not-indented-paragraph">
        3.10. Заем предоставляется Заемщику со сроком возврата, согласно Заявке одной из Сторон, графиком платежей, являющимся неотъемлемой частью договора. Срок погашения обозначает дату, не позднее которой Заемщик обязан исполнить обязательства по выплате суммы займа и процентов за пользование займом путем перечисления денежных средств в пользу Займодавца в полной сумме, согласно графика платежей.
      </p>
      <div class="offer-title">Сведения о займе и его условиях:</div>
      <div class="offer-data-container">
        <div class="offer-container">
        <div class="offer-item">Сумма займа, бел. руб.</div>
        <div class="offer-item">{{ offerAmount }}</div>
        <div class="offer-item">Срок займа (дней)</div>
        <div class="offer-item">{{ offerTerm }}</div>
      </div>
      <div class="offer-container">
        <div class="offer-item">Дата получения займа</div>
        <div class="offer-item">{{ date }}</div>
        <div class="offer-item">Ставка за пользование займом, в процентах годовых (r)</div>
        <div class="offer-item">{{ offerPercent }}</div>
      </div>
      <div class="offer-container">
        <div class="offer-item">Дата погашения займа</div>
        <div class="offer-item">{{ offerIssueDate }}</div>
        <div class="offer-item">Способ погашения</div>
        <div class="offer-item">Всё в конце</div>
      </div>
      </div>
      <div class="offer-title">Первоначальный график платежей:</div>
      <div class="payment-data-container">
        <div class="payment-container">
        <div class="payment-item">Номер платежа</div>
        <div class="payment-item">Дата платежа</div>
        <div class="payment-item">Сумма платежа</div>
        <div class="payment-item">в т.ч. основной долг</div>
        <div class="payment-item">в т.ч. проценты</div>
      </div>
      <div class="payment-container">
        <div class="payment-item">1</div>
        <div class="payment-item">{{ offerIssueDate }}</div>
        <div class="payment-item">{{ offerTotalAmount }}</div>
        <div class="payment-item">{{ offerAmount }}</div>
        <div class="payment-item">{{ offerExpextedIncome }}</div>
      </div>
      </div>
      <p class="not-indented-paragraph">
        Способы обеспечения исполнения обязательств по Договору Займа не предусмотрены.
      </p>
      <div class="block-title">4. ПРАВА И ОБЯЗАННОСТИ СТОРОН</div>
      <p class="not-indented-paragraph">
        <b>Заемщик вправе:</b> 
          <br>
        4.1. Распоряжаться по своему усмотрению денежными средствами, полученными от Заимодавца, и, при должном исполнении условий Договора, сумма основных процентов за пользование займом будет равна сумме процентов, указанных в Заявке, выставленной или акцептованной им.
      </p>
      <p class="not-indented-paragraph">
        4.2. По истечении 45 (сорока пяти) календарных дней с даты получения Займа досрочно вернуть всю сумму Займа с уплатой процентов за пользование займом за фактический срок использования займа. При этом уведомление о досрочном погашении займа, инициированное Заемщиком, направляется Заимодавцу через оповещение на Сервисе на адрес электронной почты, указанной им при регистрации и/или в Личный кабинет Заимодавца, не позднее дня, в котором происходит досрочное погашение. 
      </p>
      <p class="not-indented-paragraph">
        4.3. Получать информацию о текущей задолженности, а также о произведенных и предстоящих платежах по договору займа в своем личном кабинете на Сервисе.
      </p>
      <p class="not-indented-paragraph">
        <b>Заемщик обязан:</b> 
          <br>
          4.4. Заемщик обязуется обеспечить возврат предоставленных Заимодавцем заемных денежных средств, а также уплатить проценты за пользование займом в сроки и в порядке, определенные в соответствии с настоящим Договором и Правилами.
      </p>
      <p class="not-indented-paragraph">
        4.5. Оплатить Заимодавцу начисленные неустойку (пени), в случае просрочки выплаты основной суммы Займа и (или) процентов за пользование займом.
      </p>
      <p class="not-indented-paragraph">
        4.6. Обеспечить наличие открытого текущего (расчетного) банковского счета в банке Республики Беларусь (с использованием банковской платежной карточки) до момента осуществления расчетов по займу
      </p>
      <p class="not-indented-paragraph">
        4.7. Заемщик гарантирует, что он является конечным выгодоприобретателем по Договору Займа и не действует в интересах иных лиц.
      </p>
      <p class="not-indented-paragraph">
        <b>Ответственность Заемщика:</b> 
          <br>
          4.8. В случае просрочки платежа, предусмотренного Первоначальным графиком платежей Заемщик обязуется уплатить Заимодавцу неустойку (пени) из расчета двукратной процентной ставки за пользование займом (r) по Договору от суммы неисполненного денежного обязательства за каждый календарный день просрочки исполнения. При этом неустойка (пени) в рамках настоящего Договора не может превышать половины суммы займа, предоставленного Заемщику.
      </p>
      <p class="not-indented-paragraph">
        4.9. Заемщик возмещает Заимодавцу убытки, понесенные последним вследствие неисполнения (ненадлежащею исполнения) обязательств по настоящему Договору, включая судебные издержки и др.
      </p>
      <p class="not-indented-paragraph">
        4.10. Заемщик обязан рассчитаться по всем обязательствам, вытекающим из настоящего Договора при выезде на постоянное место жительства за пределы Республики Беларусь.
      </p>
      <p class="not-indented-paragraph">
        <b>Заимодавец вправе:</b> 
          <br>
          4.11. В любой момент уступить права требования по настоящему договору любому третьему лицу с направлением уведомления об этом Заемщику, который в таком случае производит исполнение обязательств, предусмотренных настоящим договором, новому Заимодавцу.
      </p>
      <p class="not-indented-paragraph">
        4.12. При уступке права требования по Договору Займа, Оператор, равно как и Заимодавец вправе передавать персональные данные Заемщика в соответствии с законодательством.
      </p>
      <p class="not-indented-paragraph">
        <b>Ответственность Заимодавца:</b> 
          <br>
          4.13. При отсутствии на Сервисе сведений о действительных платежных реквизитах Заимодавца, невозможности зачисления денежных средств в связи с блокировкой или окончанием действия карт, все потери, связанные с невозможностью Заемщика исполнить обязательства по платежу перед Заимодавцем, относятся на счет Заимодавца. 
      </p>
      <p class="not-indented-paragraph">
        4.14. Заимодавец не вправе изменять условия или требовать прекращения Договора в одностороннем порядке при своевременном и надлежащем исполнении Заемщиком своих обязательств.
      </p>
      <p class="not-indented-paragraph">
        <b>Стороны имеют право:</b> 
          <br>
          4.15. Самостоятельно знакомиться с информацией об условиях предоставления займов, Правилами Оператора и ДВУ, а также с нормами действующего законодательства, регулирующего деятельность сервисов онлайн-заимствования, в т.ч. на официальном сайте по адресам: <a href="https://www.kapusta.by" target="_blank">www.kapusta.by</a> и <a href="https://www.капуста.бел" target="_blank">www.капуста.бел</a>.
      </p>
      <p class="not-indented-paragraph">
        4.16. Требовать от Оператора обоснование списания сумм в случае возникновения спорных вопросов, предоставив Оператору все квитанции, чеки, расширенные банковские выписки по счету, выданные Сторонам настоящего Договора по совершенным операциям, списание денежных средств по которым явилось основанием для претензии.
      </p>
      <p class="not-indented-paragraph">
        <b>Стороны обязаны:</b> 
          <br>
          4.17. Самостоятельно регулировать свои отношения и порядок расчетов с налоговыми органами. 
      </p>
      <div class="block-title">5. РАСЧЁТЫ СТОРОН</div>
      <p class="not-indented-paragraph">
        5.1. Стороны признают, что все расчеты Сторон по настоящему Договору осуществляются в безналичной форме, путем зачисления денежных средств на текущий (расчетный) банковский счет (с использованием банковской платежной карточки) получателя, в соответствии с условиями Правил Оператора, ДВУ, которые в т.ч. регулируют вопросы и правила совершения сделок займа по настоящему Договору посредством Сервиса.
      </p>
      <p class="not-indented-paragraph">
        5.2. Все расчеты Сторон по настоящему Договору осуществляются посредством перечисления денежных средств по соответствующим банковским платежным реквизитам, указанным Сторонами на Сервисе в соответствующем разделе «Личный кабинет».
      </p>
      <p class="not-indented-paragraph">
        5.3. Погашение Займа может происходить только путем перечисления денежных средств с текущего (расчетного) банковского счета (с использованием банковской платежной карточки) в размере и в срок, указанные в Графике платежей, при этом денежные средства по Правилам и в соответствии с ДВУ списываются с текущего (расчетного) банковского счета плательщика. Заемщик может погасить заем полностью или частично или произвести досрочный возврат займа, в соответствии с п.4.2. настоящего Договора. 
      </p>
      <p class="not-indented-paragraph">
        5.4. Погашение обязательств может осуществляться единовременно либо частями по желанию Заемщика. 
      </p>
      <p class="not-indented-paragraph">
        5.5. В случае, когда перечисляемая Заемщиком сумма денежных средств недостаточна для расчета с Заимодавцем по обязательствам, вытекающим из настоящего Договора, уплаченная сумма направляется на погашение долга в следующем порядке:
      </p>
      <p class="not-indented-paragraph">
        а) просроченная задолженность по основному долгу по займу с приоритетом погашения ранее исчисленной его части, если это определено графиком платежей;
      </p>
      <p class="not-indented-paragraph">
        б) просроченная задолженность по процентам за пользование займом с приоритетом погашения ранее исчисленной их части, если это определено графиком платежей;
      </p>
      <p class="not-indented-paragraph">
        в) неустойка (пени) с приоритетом погашения ранее начисленной;
      </p>
      <p class="not-indented-paragraph">
        г) срочная задолженность по займу с приоритетом погашения сначала основного долга, затем процентов за пользование займом.
      </p>
      <p class="not-indented-paragraph">
        5.6. Проценты за пользование займом исчисляются при выдаче займа в процентах годовых, начисляются за каждый оговоренный календарный день пользования займом по день возврата (погашения) займа включительно. При начислении процентов количество дней в месяце принимается равным фактическому – 28/29/30/31. Количество дней в году соответственно - 365/366. 
      </p>
      <p class="not-indented-paragraph">
        5.7. Процентная ставка, как и иные условия по займу устанавливаются в Заявке, размещенной Заемщиком или Заимодавцем в рамках оферты на Сервисе и акцептуется Заимодавцем или Заемщиком соответственно. Расчетные суммы процентов, подлежащие уплате, отражены в Первоначальном графике платежей в Договоре (в значениях на момент его заключения) и в соответствующем разделе - «Личный кабинет» на Сервисе (в актуальных значениях на момент входа в личный кабинет). При досрочном возврате займа Заемщиком (при наличии и использовании соответствующих инструментов Сервиса) исчисленные проценты пересчитываются и подлежат уплате в полном вновь исчисленном объеме в зависимости от изменения срока возврата займа в связи с досрочным погашением.
      </p>
      <p class="not-indented-paragraph">
        5.8. Проценты за пользование займом подлежат уплате в соответствии с графиком платежей и/или фактическим сроком пользования займом, путем перечисления денежных средств в пользу Заимодавца через команду Сервису или путем автоматического списания Сервисом.
      </p>
      <p class="not-indented-paragraph">
        5.9. Датой исполнения обязательств по договору Займа считается момент списания денежных средств с текущего (расчетного) банковского счета плательщика.
      </p>
      <div class="block-title">6. ФОРС-МАЖОР</div>
      <p class="not-indented-paragraph">
        6.1. Заемщик не несет ответственность перед Заимодавцем за полное или частичное невыполнение обязательств, вызванных обстоятельствами, возникшими помимо воли и желания Сторон, которые нельзя было предвидеть или избежать (форс-мажор), а именно и исчерпывающе: объявленная война, чрезвычайная ситуация, в том числе техногенного характера, действия государственных органов Республики Беларусь, при условии прямого отношения указанных событий к Заемщику и наличия разумной причинно-следственной связи между их наступлением и невозможностью исполнения своих обязательств в рамках настоящего договора.
      </p>
      <p class="not-indented-paragraph">
        6.2. Сторона, которая не исполняет свои обязательства вследствие действия непреодолимой силы, должна известить другую Сторону о препятствии и его влиянии на исполнение обязательств без промедления, но не позднее 48 (сорока восьми) часов с момента наступления указанных обстоятельств. Сторона, не известившая другую Сторону о невозможности исполнения своих обязательств по настоящему Договору, теряет право ссылаться на такую невозможность.
      </p>
      <div class="block-title">7. ПРОЧИЕ УСЛОВИЯ</div>
      <p class="not-indented-paragraph">
        7.1. Все споры по настоящему договору подлежат рассмотрению в третейском суде Общества с ограниченной ответственностью «Инновационные Финансовые Стратегии» (УНП 193601287). Язык судопроизводства - русский. Разрешение споров осуществляется третейским судом в составе одного судьи – председателя третейского суда (единолично). В случае, если в силу законодательства либо регламента третейского суда Общества с ограниченной ответственностью «Инновационные Финансовые Стратегии» рассмотрение спора в соответствии с ч.1 настоящего пункта невозможно, и третейская оговорка по каким-либо причинам не действует, то спор по настоящему договору подлежит рассмотрению в Суде Центрального района г. Минска по договорной подсудности. Для разрешения споров и разногласий, связанных с настоящим договором, стороны устанавливают обязательный претензионный порядок. Претензия должна содержать извещение о нарушении условий договора с обоснованием, а также требования, которые, по мнению стороны, предъявляющей претензию, подлежат удовлетворению. Сторона, получившая претензию, в течение 10 рабочих дней после получения претензии обязана мотивированным письмом сообщить другой стороне о результатах ее рассмотрения. Претензия и ответ на претензию направляются по адресам электронной почты Сторон, указанным в соответствующем разделе Личного кабинета на Сервисе, а также по адресу электронной почты третейского суда Общества с ограниченной ответственностью «Инновационные Финансовые Стратегии»: <a href="mailto:court@ifs.by" target="_blank">court@ifs.by</a>.
      </p>
      <p class="not-indented-paragraph">
        7.2. Стороны пришли к соглашению, что в случае передачи спора на рассмотрение в третейский суд Общества с ограниченной ответственностью «Инновационные Финансовые Стратегии» вся корреспонденция третейского суда (в том числе определения, решения, извещения и другие процессуальные документы), будет направляться третейским судом по адресам электронной почты Сторон, указанным в соответствующем разделе Личного кабинета на Сервисе.
      </p>
      <p class="not-indented-paragraph">
        7.3. При изменении своего адреса электронной почты в период действия настоящего Договора соответствующая Сторона обязана изменить его путем внесения нового адреса электронной почты в своем Личном кабинете на Сервисе не позднее следующего рабочего дня со дня изменения адреса электронной почты. В случае, если изменение адреса электронной почты соответствующей Стороны произошло после передачи спора на рассмотрение в третейский суд Общества с ограниченной ответственностью «Инновационные Финансовые Стратегии», эта Сторона обязана в письменном виде на адрес электронной почты третейского суда направить уведомление (с указанием своих персональных данных) об изменении своего адреса электронной почты. Третейский суд Общества с ограниченной ответственностью «Инновационные Финансовые Стратегии» будет направлять всю корреспонденцию соответствующей Стороне по новому адресу электронной почты, если эта Сторона надлежащим образом в соответствии с условиями настоящего пункта договора известила Сервис или третейский суд об изменении своего адреса электронной почты. В случае невыполнения Стороной обязанности по извещению об изменении своего адреса электронной почты третейский суд будет направлять всю корреспонденцию соответствующей Стороне по адресу электронной почты, указанному при заключении настоящего Договора, и это будет являться надлежащим способом процессуального извещения Стороны о ходе рассмотрении спора третейским судом.
      </p>
      <p class="not-indented-paragraph">
        7.4. Переписка и обмен документами, исходящими/входящими с/на электронные почты, принадлежащие Сторонам, а также третейскому суду Общества с ограниченной ответственностью «Инновационные Финансовые Стратегии», может осуществляться без применения электронной цифровой подписи.
      </p>
      <p class="not-indented-paragraph">
        7.5. Адрес электронной почты третейского суда Общества с ограниченной ответственностью «Инновационные Финансовые Стратегии»: <a href="mailto:court@ifs.by" target="_blank">court@ifs.by</a>
      </p>
      <p class="not-indented-paragraph">
        <br>
        <br>
        Сторонам полностью ясны все понятия, термины, смыслы и значения, используемые в тексте настоящего Договора. Им также понятны права и обязанности в связи с заключением настоящего Договора. Стороны отдают себе отчет в своих финансовых возможностях, отрицая возможный кабальный характер сделки. Заимодавец осознает и принимает все возможные риски, связанные с предоставлением Займа. Стороны действуют разумно, добросовестно, без принуждения и исключительно в своих собственных интересах.
      </p>
      <p class="not-indented-paragraph">
        <br>
        <br>
        Регистрация на Сервисе и идентификация Сторон по Договору произведена через МСИ и выполнена с использованием двухфакторной аутентификации. Личность Сторон по настоящему Договору верифицирована и аутентична. Договор подписан Заемщиком с использованием АСП, Заимодавец полностью присоединяется к данному Договору путем совершения действий, свидетельствующих о перечислении денежных средств Заемщику в рамках условий настоящего Договора.
      </p>
      <div class="block-title">ПОДПИСЬ ЗАЕМЩИКА</div>
      <div class="sign-offer-block">
        <div class="sign-offer-item">
          <div
            class="check-box-btn"
            :class="{ 'check-box-checked': isAgreeWithServiceAgreement }"
            @click.stop="checkboxHandler()"
          >
            <img
              v-if="isAgreeWithServiceAgreement"
              class="check-box-image"
              src="../../../public/custom/images/check.svg"
              alt="Checket image"
            />
          </div>
          <div
            class="check-box-label"
            @click.stop="checkboxHandler()"
          >
          Текст Договора прочитан мной полностью, с условиями Договора ознакомлен(а) и согласен(а)
          </div>
        </div>
        <div class="otp-container">
          <div class="otp-block">
            <base-text-input
              :mask-pattern="'######'"
              :name="'otp'"
              :validate-rules="'otp'"
              :placeholder="$t('message.contract.otp.placeholder')"
              v-model="otp"
              :disabled="isSignBtnLoading"
            />
          </div>
          <div class="send-otp-block" @click="getOtpCode()">Получить код</div>
        </div>
      </div>
      <div class="borrower-sign-block">
        <div>Заемщик:</div>
        <div class="full-name">{{ userLastName }} {{ userName }} {{ userMiddleName }}</div>
      </div>
      <div class="btns-block">
        <div class="btn-container">
          <base-button
            :text="$t('message.contract.btn')"
            :disabled="isSignBtnDisabled"
            @click="signAgreement()"
            :is-loading="isSignBtnLoading"
          />
        </div>
      </div>
    </div>
    <base-modal v-if="isShowSuccessModal" @close="closeSuccessModal()">
      <template #header>
        <div class="modal-header">
          <img @click.stop="closeSuccessModal()" class="close-image" src="../../../public/custom/images/cross.svg" alt="Cross image">
        </div>
        <div class="modal-title">
          {{ $t('message.contract.successModal.title') }}
        </div>
        <div class="modal-desc">
          <span>
            {{ $t('message.contract.successModal.desc.text') }}
            <router-link class="modal-desc-link" to="/profile">
              {{ $t('message.contract.successModal.desc.link') }}
            </router-link>
          </span>
        </div>
        <div class="modal-btn-block">
          <base-button
            :text="$t('message.contract.successModal.btn')"
            @click="closeSuccessModal()"
          />
        </div>
      </template>
    </base-modal>

    <base-modal v-if="isShowErrorModal" @close="closeErrorModal()">
      <template #header>
        <div class="modal-header">
          <img @click.stop="closeErrorModal()" class="close-image" src="../../../public/custom/images/cross.svg" alt="Cross image">
        </div>
        <div class="modal-title modal-error-title">
          <span>{{ $t('message.contract.errorModal.title') }}</span>
        </div>
        <div class="modal-desc">
          <span>{{ $t('message.contract.errorModal.desc') }}</span>
        </div>
        <div class="modal-btn-block">
          <base-button
            :text="$t('message.contract.errorModal.btn')"
            @click="closeErrorModal()"
          />
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTextInput from '../../components/base/BaseTextInput.vue';
import BaseButton from '../../components/base/BaseButton.vue';
import BaseSpinner from '../../components/base/BaseSpinner.vue';
import BaseModal from '../../components/base/BaseModal.vue';

export default {
  name: 'Contract',
  inject: ['$httpService'],
  components: {
    BaseTextInput,
    BaseButton,
    BaseSpinner,
    BaseModal
  },
  async created() {
    const agreement_id = this.$route.query?.agreement_id;

    if (agreement_id) {
      const response = await this.$httpService.loan.getLoanData(agreement_id);

        this.agreementId = response.data.agreementId;
        this.offerData = response.data.offer;
        this.loanData = response.data.loan;
        this.lender = response.data.lender;
        this.isLoading = false;
    } 
  }, 
  data() {
    return {
      isShowSuccessModal: false,
      isShowErrorModal: false,
      isAgreeWithServiceAgreement: false,
      message_id: '',
      otp: '',
      isLoading: true,
      offerData: {

      },
      agreementId: '',
      loanData: {},
      lender: {},
      isSignBtnLoading: false
    }
  },
  computed: {
    ...mapGetters(['profile']),
    date() {
      return new Date().toLocaleDateString();
    },
    lenderName() {
      return this.lender?.fullname?.given_name_ru;
    },
    lenderLastName() {
      return this.lender?.fullname?.family_name_ru;
    },
    lenderMiddleName() {
      return this.lender?.fullname?.middle_name_ru;
    },
    lenderEmail() {
      return this.lender?.contacts[0];
    },
    userName() {
      return this.profile?.name_ru?.given_name_ru;
    },
    userLastName() {
      return this.profile?.name_ru?.family_name_ru;
    },
    userMiddleName() {
      return this.profile?.name_ru?.middle_name_ru;
    },
    userEmail() {
      return this.profile?.email;
    },
    userNationalIdNumber() {
      return this.profile?.national_id_number;
    },
    userIdDocumentType() {
      return this.$t(`message.signUp.idBlock.mainDocument.list.${this.profile?.id_document?.type}`)
    },
    userIdSeriesNumber() {
      return this.profile?.id_document?.seriesNumber;
    },
    userIdIssueDate() {
      const date = this.profile?.id_document?.issueDate;
      const year = date.slice(0, 4);
      const month = date.slice(4, 6);
      const day = date.slice(6, 8);
      return `${day}.${month}.${year}`;
    },
    userIdAuthority() {
      return this.profile?.id_document?.authority;
    },
    offerAmount() {
      return this.offerData?.loan_amount / 100;
    },
    offerTerm() {
      return this.offerData?.loan_term_days;
    },
    offerPercent() {
      return this.offerData?.annual_percent;
    },
    offerIssueDate() {
      // const dayInMs = 86400000; //День в миллисекундах
      // const offerTermInMs = this.offerTerm * dayInMs;
      // const currentDate = Date.now();
      // const targetDate = offerTermInMs + currentDate;

      return new Date(this.loanData?.due_date).toLocaleDateString();
    },
    offerTotalAmount() {
      return (this.offerData.loan_amount + this.offerData.expected_income) / 100;
    },
    offerExpextedIncome() {
      return this.offerData.expected_income / 100;
    },
    isHasFieldsErrors() {
      return this.errors.items.length > 0;
    },
    isHasEmptyFields() {
      return !this.otp;
    },
    isSignBtnDisabled() {
      return this.isHasFieldsErrors || this.isHasEmptyFields || !this.isAgreeWithServiceAgreement || this.isSignBtnLoading;
    }
  },
  methods: {
    closeSuccessModal() {
      this.isShowSuccessModal = false;
      this.$router.push({name: 'main'});
    },
    openSuccessModal() {
      this.isShowSuccessModal = true;
    },
    closeErrorModal() {
      this.isShowErrorModal = false;
      this.$router.push({name: 'main'});
    },
    openErrorModal() {
      this.isShowErrorModal = true;
    },
    checkboxHandler() {
      if(!this.isSignBtnLoading) {
        this.isAgreeWithServiceAgreement = !this.isAgreeWithServiceAgreement;
      }
    },
    async getOtpCode() {
      if (!this.isSignBtnLoading) {
        try {
          const response = await this.$httpService.loan.getOtpCode(this.profile?.contact?.phoneSMSVerification);

          this.message_id = response.data.message_id;
          this.$toast({text: this.$t('message.signIn.otpToastMsg')});
        } catch (error) {
          this.$router.push({name: 'main'});
        }
      }
    },
    async signAgreement() {
      this.isSignBtnLoading = true;
      try {
        const offer_public_id = this.offerData.public_id;
        const agreement_id = this.agreementId;
        const otp = +this.otp;
        const response = await this.$httpService.loan.signAgreement(offer_public_id, agreement_id, otp);
        
        if (response.data) {
          this.openSuccessModal();
        }

        this.isSignBtnLoading = false;
      } catch (error) {
        this.$store.dispatch('purgeError');
        this.openErrorModal();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .contract-wrapper {
    @include base-page-wrapper;
  }

  .contract-heading,
  .contract-container {
    @include base-page-container;
  }

  .contract-container {
    width: 1550px;
    max-width: 90%;
    flex-direction: column;
  }

  .back-btn-container {
    margin-top: 30px;
    margin-bottom: 28px;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.back-img {
    margin-right: 4px;
    height: 18px;
    width: 18px;
}

.back-btn-text {
    font-weight: 400;
    font-size: 16px;
    line-height: 135%;
    color: var(--password-recovery-back-btn-color);
}

.contract-title,
.contract-date,
.block-title,
.offer-title {
  width: 100%;
  font-family: 'Montserrat';
  font-weight: 700;
  font-size: calc(20px + 20 * (100vw / 1920));
  line-height: 125%;
  color: #121212;
  text-align: center;
}

.block-title,
.offer-title {
  font-size: calc(20px + 15 * (100vw / 1920));
  margin-top: 50px;
  margin-bottom: 50px;
  font-weight: 400;
}

.offer-title {
  font-size: calc(15px + 10 * (100vw / 1920));
  font-weight: 500;
  text-decoration: underline;
} 

.contract-date {
  margin-bottom: 100px;
}

.indented-paragraph {
  padding: 0;
  margin: 0;
  margin-bottom: 10px;
  text-indent: calc(20px + 40 * (100vw / 1920));
  font-size: calc(20px + 10 * (100vw / 1920));
  line-height: 125%;

  a {
    color: blue;
  }
}

.not-indented-paragraph {
  padding: 0;
  margin: 0;
  margin-bottom: 10px;
  text-indent: 0;
  font-size: calc(20px + 10 * (100vw / 1920));
  line-height: 125%;

  a {
    color: blue;
  }
}

.lender-container,
.borrower-container {
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  margin-bottom: 100px;
  margin-top: 100px;
}

.offer-data-container,
.payment-data-container {
  display: flex;
  flex-direction: column;
  overflow-x: auto;
}

.payment-data-container {
  margin-bottom: 50px;
}

.borrower-container {
  .name-container {
    margin-bottom: 50px;
  }
}

.name-container,
.email-container,
.id-document-container,
.id-document-authority,
.offer-container,
.payment-container,
.sign-offer-block {
  width: 100%;
  display: flex;
}

.sign-offer-block {
  flex-direction: column;
}

.id-document-container {
  margin-bottom: 50px;
}

.name-item,
.email-item,
.email-item-disabled,
.id-item,
.authority-item,
.authority-email-item,
.offer-item,
.payment-item {
  min-width: 400px;
  min-height: 69.5px;
  width: calc(100% / 3);
  padding: 15px;
  box-sizing: border-box;
  border: 1px solid black;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: calc(10px + 15 * (100vw / 1920));
  line-height: 125%;
  font-weight: 500;
  text-align: center;
}

.offer-item,
.payment-item {
  min-height: 100px;
  text-align: start;
  justify-content: flex-start;
}

.payment-item {
  width: calc(100% / 5);
}

.offer-item {
  width: calc(100% / 4);
}

.authority-item {
  min-width: 720px;
  width: 60%;
}

.authority-email-item {
  width: 40%;
  min-width: 480px;
}

.id-item,
.offer-item {
  min-width: 300px;
}

.payment-item {
  min-width: 240px;
}

.email-item-disabled {
  border: 1px solid lightgrey;
}

.email-item:first-of-type {
  border-top: none;
}

.name-item:nth-of-type(3),
.name-item:nth-of-type(2) {
  border-left: none;
}

.sign-offer-item {
  margin-bottom: 50px;
  display: flex;
  align-items: flex-start;
}

.check-box-btn {
  @include base-check-box;
  width: 34px;
  height: 34px;
}

.check-box-label {
  @include base-check-box-label;

  font-size: calc(15px + 10 * (100vw / 1920));
  line-height: 125%;
  font-weight: 500;
}

.otp-container {
  display: flex;
  align-items: center;
}

.otp-block {
  width: 197px;
  margin-right: 20px;
}

.send-otp-block {
  margin-bottom: 30px;
  font-weight: 400;
  font-size: 16px;
  line-height: 135%;
  letter-spacing: 0.01em;
  text-decoration-line: underline;
  color: #41BF7B;
  cursor: pointer;
}

.btns-block {
  margin-top: 100px;
  margin-bottom: 200px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.btn-container {
  width: 300px;
  height: 65px;
}

.borrower-sign-block {
  margin: 50px 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: calc(10px + 15 * (100vw / 1920));
  line-height: 125%;
}

.full-name {
  text-decoration: underline;
}

.modal-header {
  @include modal-close-block;
}

.modal-title {
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  justify-content: center;
  font-weight: 700;
  font-size: 22px;
  line-height: 125%;
  text-align: center;
  color: #41BF7B;
}

.modal-error-title {
  color: #EB5757;
}

.modal-desc {
  margin-bottom: 30px;
  width: 580px;
  max-width: 75%;
  display: flex;
  justify-content: center;
  font-weight: 500;
  font-size: 20px;
  line-height: 125%;
  text-align: center;
  color: #101010;
}

.modal-desc-link {
  color: #41BF7B;
}

.modal-btn-block {
  margin-bottom: 27px;
  width: 65px;
  height: 40px;
}

@media screen and (max-width: 750px) {
  .modal-desc {
    max-width: 100%;
  }
}
</style>